<template>
  <woot-modal
    :show.sync="show"
    :on-close="onCancel"
    style="overflow: hidden !important;"
  >
    <div class="column" style="overflow: hidden !important;">
      <woot-modal-header
        :header-title="$t('EMAIL_TRANSCRIPT.TITLE')"
        :header-content="$t('EMAIL_TRANSCRIPT.DESC')"
      />
      <woot-tabs
        class="settings--tabs"
        style="padding: 2.4rem;"
        :index="selectedTabIndex"
        :border="false"
        @change="onTabChange"
      >
        <woot-tabs-item
          v-for="tab in tabs"
          :key="tab.key"
          :test-id="tab.testid"
          :name="tab.name"
          :show-badge="false"
        />
      </woot-tabs>
      <email-transcript-form
        v-if="selectedTabKey === 'send_transcript'"
        :current-chat="currentChat"
        @on-cancel="onCancel"
      />
      <print-transcript-form
        v-else-if="selectedTabKey === 'print'"
        :current-chat="currentChat"
        @on-cancel="onCancel"
      />
    </div>
  </woot-modal>
</template>

<script>
import EmailTranscriptForm from './EmailTranscriptForm.vue';
import PrintTranscriptForm from './PrintTranscriptForm.vue';
export default {
  components: { PrintTranscriptForm, EmailTranscriptForm },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedTabIndex: 0,
    };
  },
  computed: {
    selectedTabKey() {
      return this.tabs[this.selectedTabIndex]?.key;
    },
    tabs() {
      return [
        {
          key: 'send_transcript',
          name: 'Send',
          testid: 'Send',
        },
        {
          key: 'print',
          name: 'Print',
          testid: 'Print',
        },
      ];
    },
  },
  methods: {
    onTabChange(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
